import { Inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { ACCOUNT_OPEN_REFERENCE_ID_PARAM_NAME } from 'constants/shared-constants';
import { LOCAL_STORAGE, StorageService } from 'ngx-webstorage-service';

@Injectable({
  providedIn: 'root',
})
/// handles GA, FA and depot-experte codes
export class PromotionService {
  public readonly refIdKey = '_p'; // key to store the accountOpenReferenceId from FA in local storage
  public readonly gaKey = '_g'; // key to store the params from GA in local storage

  constructor(@Inject(LOCAL_STORAGE) private localStorage: StorageService) {}

  public storePromotionInfo(routeSnapshot: ActivatedRouteSnapshot): void {
    try {
      // handle KWK
      if (routeSnapshot.queryParamMap.has(ACCOUNT_OPEN_REFERENCE_ID_PARAM_NAME)) {
        let paramValue = routeSnapshot.queryParams[ACCOUNT_OPEN_REFERENCE_ID_PARAM_NAME] as string;
        if (paramValue.toLowerCase().startsWith('kwk-')) {
          paramValue = paramValue.substring(0, 16);
        }

        this.localStorage.set(this.refIdKey, paramValue);

        // handle Finance Ads
      } else if (routeSnapshot.queryParamMap.has('s_id')) {
        const sid = routeSnapshot.queryParamMap.get('s_id');
        this.localStorage.set(this.refIdKey, `FAS-${sid}`);

        // handle depot-expert
      } else if (routeSnapshot.queryParamMap.has('click_id')) {
        const clickId = routeSnapshot.queryParamMap.get('click_id');
        this.localStorage.set(this.refIdKey, `DEX-${clickId}`);
      }

      // handle GA
      const gaObjList = [];
      for (const queryParamKey of routeSnapshot.queryParamMap.keys) {
        if (queryParamKey.startsWith('utm_') || queryParamKey.startsWith('utfz_')) {
          const gaObj = {
            prefix: undefined,
            parameter: undefined,
            value: undefined,
          };
          gaObj.prefix = 'utm_';
          if (queryParamKey.startsWith('utfz_')) {
            gaObj.prefix = 'utfz_';
          }
          gaObj.parameter = queryParamKey.replace(/^utfz_/, 'utm_');
          gaObj.value = routeSnapshot.queryParamMap.get(queryParamKey);
          gaObjList.push(gaObj);
        }
      }
      if (gaObjList.length > 0) {
        this.localStorage.set(this.gaKey, gaObjList);
      }
      // eslint-disable-next-line no-empty
    } catch (e) {}
  }

  public getAccountOpenReferenceId(): string {
    return this.localStorage.get(this.refIdKey) || '';
  }

  public deletePromotionInfo(): void {
    try {
      this.localStorage.remove(this.refIdKey);
      // eslint-disable-next-line no-empty
    } catch (e) {}
  }

  public getGaParams(): any[] {
    return this.localStorage.get(this.gaKey) || [];
  }
}
